require('./bootstrap')
import $ from 'jquery'
window.$ = window.jQuery = $
import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap
import Swal from 'sweetalert2'
window.Swal = Swal
import Sortable from 'sortablejs';
window.Sortable = Sortable;

window.__ = function(key) {
    return window.I18n[key] || key;
};

import select2 from 'select2';

import 'select2/dist/css/select2.min.css';
import 'select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.min.css';

import './_main'
import './_alerts'
import './_themeSwitcher'


document.addEventListener('DOMContentLoaded', function() {
    let deferredPrompt;

    const installToast = document.getElementById('pwa-install-toast');
    const installBtn = document.getElementById('pwa-install-btn');
    const closeBtn = document.getElementById('pwa-close-btn');

    // Logic to check if the app is already running in "App Mode"
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches
        || window.navigator.standalone
        || document.referrer.includes('android-app://');

    window.addEventListener('beforeinstallprompt', (e) => {
        // 1. Don't show if already in standalone app mode
        if (isStandalone) return;

        // 2. Prevent the default browser mini-bar
        e.preventDefault();
        deferredPrompt = e;

        // 3. Only show if the user hasn't dismissed it before
        if (installToast && !localStorage.getItem('pwa_dismissed')) {
            installToast.style.setProperty('display', 'block', 'important');
        }
    });

    installBtn?.addEventListener('click', async () => {
        if (!deferredPrompt) return;

        // Trigger the native browser dialog
        deferredPrompt.prompt();

        const { outcome } = await deferredPrompt.userChoice;

        if (outcome === 'accepted') {
            installToast.style.display = 'none';
        }

        // Reset the prompt variable (can only be used once)
        deferredPrompt = null;
    });

    closeBtn?.addEventListener('click', () => {
        if (installToast) {
            installToast.style.display = 'none';
        }
        // Remember dismissal so we don't show it again
        localStorage.setItem('pwa_dismissed', 'true');
    });

    // Cleanup if app is installed by other means (e.g., browser menu)
    window.addEventListener('appinstalled', () => {
        if (installToast) installToast.style.display = 'none';
        deferredPrompt = null;
    });
});
